module.exports = __webpack_public_path__ + "assets/shangdian.e08e8590.svg";